import { T_APP_CONFIG_CHECKER_PAGE_CONSTANTS } from './TYPES'

const EN_APP_CONFIG_CHECKER_PAGE_CONSTANTS: T_APP_CONFIG_CHECKER_PAGE_CONSTANTS =
  {
    OPTIONAL_UPDATE_HEADER: 'Update Available',
    OPTIONAL_UPDATE_DESCRIPTION:
      'To enjoy the latest features and improvements, please update the application.',
    OPTIONAL_UPDATE_CONFIRM_BTN_TEXT: 'Update',
    OPTIONAL_UPDATE_CANCEL_BTN_TEXT: 'Not Now',
    FORCE_UPDATE_HEADER: 'Update Required',
    FORCE_UPDATE_DESCRIPTION:
      'A new version of the app is available and required to continue. Please update now to proceed.',
    FORCE_UPDATE_CONFIRM_BTN_TEXT: 'Update Now'
  }

export default EN_APP_CONFIG_CHECKER_PAGE_CONSTANTS
